import { useState } from "react";
import { Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import { useEffect } from 'react';
import upload from '../../Images/profile/img-upload.svg'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useMemo } from 'react'
import SelectCountry from 'react-select'
import countryList from 'react-select-country-list'
import './profile.css'
import { useDispatch, useSelector } from "react-redux";
import { getUserDetail, updateUserDetailData } from "../../Actions/UserDetailAction";
import dayjs from "dayjs";
import { ToastError, ToastInfo, ToastSuccess } from "../../CustomToaster/CustomToaster";
import api from "../../utils/axiosInstance";
import { InputError } from "../Errors/ErrorText";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { handleImageError } from "../../Helper/helper";

const customStyles = {
    control: (provided) => ({
        ...provided,
        // border: "1px solid var(--color-BasicBg)",
        boxShadow: "none",
        "&:hover": {
            border: "1px solid var(--color-InputLine)",
        },
    }),

    option: (provided, state) => ({
        ...provided,
        background: state.isSelected
            ? "linear-gradient(90deg, #9E5E10 0%, #F8BC36 25%, #F8EB51 53.71%, #E89B02 78.37%, #874600 100%)"
            : state.isFocused
                ? "linear-gradient(90deg, #9E5E10 0%, #F8BC36 25%, #F8EB51 53.71%, #E89B02 78.37%, #874600 100%)"
                : "white",
        color: state.isSelected || state.isFocused ? "#000" : "#000",
        cursor: "pointer",
    }),

    singleValue: (provided) => ({
        ...provided,
        color: "#fff",
    }),

    menu: (provided) => ({
        ...provided,
        borderRadius: "8px",
        overflow: "hidden",
    }),
};


function MyProfile() {
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.down("md"));

    //custom code
    const [edit, setEdit] = useState(false)

    const dispatch = useDispatch();
    const { userDetailData } = useSelector((state) => state.user);

    useEffect(() => {
        // Fetch user data initially
        dispatch(getUserDetail());
    }, []);

    const [formData, setFormData] = useState({
        firstName: userDetailData?.firstName || "",
        profileimg: userDetailData?.profileimg || "",
        lastName: userDetailData?.lastName || "",
        email: userDetailData?.email || "",
        phone: userDetailData?.phone || "",
        DOB: userDetailData?.DOB || null,
        address: userDetailData?.address || "",
        city: userDetailData?.city || "",
        countryVal: "IN",
        country: userDetailData?.country || "",
        nationality: userDetailData?.nationality || "",
    });
    const [originalData, setOriginalData] = useState({
        firstName: userDetailData?.firstName || "",
        profileimg: userDetailData?.profileimg || "",
        lastName: userDetailData?.lastName || "",
        email: userDetailData?.email || "",
        phone: userDetailData?.phone || "",
        DOB: userDetailData?.DOB || null,
        address: userDetailData?.address || "",
        city: userDetailData?.city || "",
        countryVal: "IN",
        country: userDetailData?.country || "",
        nationality: userDetailData?.nationality || "",
    });

    const [formErrors, setFormErrors] = useState({});

    const [value, setValue] = useState("");
    const options = useMemo(() => countryList().getData(), []);

    const changeHandler = (selected) => {
        setValue(selected);
        setFormData({
            ...formData,
            country: selected?.label,
            countryVal: selected?.value,
        });
        setFormErrors({
            ...formErrors,
            country: "",
        });
    };

    const handlePhoneChange = (value, country) => {
        setFormErrors({
            ...formErrors,
            phonenumber: "",
        });
        if (value.startsWith(country.dialCode)) {
            setFormData({
                ...formData,
                phone: `+${value}`,
                countryVal: country?.iso2?.toUpperCase(),
            });
        }
    };

    const [selectedImage, setSelectedImage] = useState(null);
    const [load, setLoad] = useState(false)

    const handleSubmit = async () => {
        const errors = {};

        if (!formData.firstName.trim()) errors.firstName = "first name is required";
        else if (formData.firstName.trim().length > 15) errors.firstName = "first name must be 15 characters or less";
        if (!formData.lastName.trim()) errors.lastName = "last name is required";
        else if (formData.lastName.trim().length > 15) errors.lastName = "last name must be 15 characters or less";
        if (!formData.DOB) errors.DOB = "date of birth is required";
        else {
            const age = dayjs().diff(dayjs(formData.DOB), 'year');
            if (age < 17 || age > 70) errors.DOB = "age must be between 17 and 70 years";
        }
        if (!formData.country) errors.country = "country is required";

        if (!formData.phone.trim()) errors.phonenumber = "phone number is required";
        // if (!isValidPhoneNumber(formData.phone, formData?.countryVal)) {
        //     errors.phonenumber = "Enter a valid phone number";
        // }

        if (!formData.nationality.trim()) {
            errors.nationality = "nationality is required";
        } else if (!/^[a-zA-Z\s]+$/.test(formData.nationality.trim())) {
            errors.nationality = "enter a valid nationality (letters only)";
        } else if (formData.nationality.trim().length > 50) {
            errors.nationality = "nationality must be 50 characters or less";
        }

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setFormErrors({}); // clear errors if no issues

        try {
            const form = new FormData();

            // Only include changed fields
            const changedFields = {};
            const keysToCompare = Object.keys(formData);
            keysToCompare.forEach((key) => {
                if (formData[key] !== originalData[key]) {
                    changedFields[key] = formData[key];
                }
            });

            // Append only changed fields to form
            for (const key in changedFields) {
                form.append(key, changedFields[key]);
            }

            // Append image if changed
            if (selectedImage instanceof File) {
                form.append("image", selectedImage);
            }

            // Skip if no changes
            if (form.entries().next().done) {
                ToastInfo({ message: "Your profile is already up to date." });
                return;
            }
            setLoad(true)

            const response = await api.post("/user/updateuser", form, { headers: { "Content-Type": "multipart/form-data" } });

            if (response.status === 200 && response.data.success) {
                ToastSuccess({ message: response.data.message });

                setEdit(true);

                const updatedUser = response.data.result;
                dispatch(updateUserDetailData(updatedUser));
                dispatch(getUserDetail())
                setFormData((prev) => ({ ...prev, ...updatedUser }));
                setOriginalData((prev) => ({ ...prev, ...updatedUser }));
                // setSelectedImage(null);
                setLoad(false)

            } else {
                ToastError({ message: response.data.message });
                setLoad(false)


            }
        } catch (err) {
            ToastError({ message: "Failed to update" });

        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const validTypes = ["image/jpeg", "image/jpg", "image/png"];
        const maxSizeInBytes = 1 * 1024 * 1024; // 1 MB

        // Validate file type
        if (!validTypes.includes(file.type)) {
            ToastError({ message: "Only JPEG, JPG, or PNG files are allowed." });
            return;
        }

        // Validate file size
        if (file.size > maxSizeInBytes) {
            ToastError({ message: "File size must be 1 MB or less." });
            return;
        }

        const imageUrl = URL.createObjectURL(file);
        setSelectedImage(imageUrl);

        setFormData({
            ...formData,
            image: file,
        });
    };




    // Compose backend image URL with timestamp to bust cache
    const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(
        /\/$/,
        ""
    );


    const profileImgPath = userDetailData?.profileImg
        ? userDetailData.profileImg.startsWith("/")
            ? userDetailData.profileImg
            : "/" + userDetailData.profileImg
        : null;


    const profileImageUrl = profileImgPath
        ? profileImgPath
        : null;



    const today = dayjs();
    const maxDate = today.subtract(17, "year");
    const minDate = today.subtract(70, "year");



    return (
        <div className="Kyc">
            <Box component="main" sx={{ marginTop: "50px", margin: "0 auto", }} >
                <div className="display-2 mb-20" >
                    <h2 className="gold-color">My Profile</h2>
                </div>
                <div className="card-box">
                    <Grid container spacing={2}>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>

                            <div style={{ display: "flex", flexDirection: md ? "column" : "row", alignItems: "center", gap: 15 }}>
                                <div>
                                    <input type="file" id="file-input" className="upload-bt" style={{ display: 'none' }} onChange={handleImageChange} accept="image/*" />
                                    {selectedImage ? (
                                        <div class="upload-img" style={{ border: "1px solid #F8BC36", borderRadius: "8px" }}>
                                            <div>
                                                <img
                                                    alt="Selected"
                                                    style={{ width: "100px", height: '100px', objectFit: 'cover' }}
                                                    src={selectedImage}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        profileImageUrl ?
                                            <img
                                                src={profileImageUrl}
                                                alt="Profile"
                                                onError={handleImageError}
                                                style={{
                                                    width: "120px",
                                                    height: "120px",
                                                    objectFit: "cover",
                                                }}
                                            />
                                            :
                                            <div class="upload-img" style={{ border: "1px solid #F8BC36", borderRadius: "8px" }}>
                                                <div>
                                                    <img alt="Selected" style={{ width: "100px", height: '100px', objectFit: 'cover' }} src={upload} />
                                                </div>
                                            </div>
                                    )
                                    }
                                </div>
                                <div className="profile-name">
                                    <h2 className="name"> {userDetailData?.firstName || "Name"}</h2>
                                    <p className="mail">{userDetailData?.email || "Email"}</p>
                                </div>
                                <div className="blu-btn">
                                    <label htmlFor="file-input">
                                        <Button onClick={() => document.getElementById('file-input').click()}>Upload</Button>
                                    </label>
                                </div>
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <div className="input-common">
                                <label>First Name</label>
                                <TextField
                                    placeholder="First Name"
                                    value={formData.firstName}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^[A-Za-z\s]*$/.test(val) && val.length <= 15) {
                                            setFormData({
                                                ...formData,
                                                firstName: val,
                                            });
                                            setFormErrors({
                                                ...formErrors,
                                                firstName: "",
                                            });
                                        }
                                    }}
                                    style={{ width: "100%", marginTop: "10px" }}
                                />

                                {formErrors.firstName && (
                                    <InputError error={formErrors.firstName} />
                                )}
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <div className="input-common">
                                <label>Last Name</label>
                                <TextField
                                    placeholder="Last Name"
                                    style={{ width: "100%", marginTop: "10px" }}
                                    value={formData.lastName}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^[A-Za-z\s]*$/.test(val) && val.length <= 15) {
                                            setFormData({
                                                ...formData,
                                                lastName: val,
                                            });
                                            setFormErrors({
                                                ...formErrors,
                                                lastName: "",
                                            });
                                        }
                                    }}
                                />

                                {formErrors.lastName && (
                                    <InputError error={formErrors.lastName} />
                                )}
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <div className="input-common date-pick">
                                <label>DOB</label>
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker
                                                sx={{ width: "100%" }}
                                                value={formData.DOB ? dayjs(formData.DOB) : null}
                                                onChange={(newValue) => {
                                                    setFormData({
                                                        ...formData,
                                                        DOB: newValue ? newValue.format("YYYY-MM-DD") : null,
                                                    });
                                                    setFormErrors({
                                                        ...formErrors,
                                                        DOB: "",
                                                    });
                                                }}
                                                minDate={dayjs("1966-01-01")}
                                                maxDate={dayjs("2009-12-31")}
                                                openTo="year"
                                                views={["year", "month", "day"]}
                                                slotProps={{
                                                    textField: {
                                                        inputProps: {
                                                            readOnly: true,
                                                        },
                                                        onKeyDown: (e) => e.preventDefault(),
                                                    },
                                                }}
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                    {formErrors.DOB && (
                                        <InputError error={formErrors.DOB} />
                                    )}
                                </div>
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <div className="input-common">
                                <label>Country</label>
                                <div className="select-country">
                                    <SelectCountry
                                        options={options}
                                        styles={customStyles}
                                        value={options.find(
                                            (opt) =>
                                                opt.label === formData.country || opt.value === formData.country
                                        )}
                                        onChange={changeHandler}
                                    />

                                    {formErrors.country && (
                                        <InputError error={formErrors.country} />
                                    )}
                                </div>
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <div className="input-common">
                                <label>Nationality</label>
                                <TextField
                                    placeholder="Nationality"
                                    style={{ width: "100%", marginTop: "10px" }}
                                    value={formData.nationality}
                                    onChange={(e) => {
                                        setFormData({ ...formData, nationality: e.target.value });
                                        setFormErrors({
                                            ...formErrors,
                                            nationality: "",
                                        });
                                    }
                                    }
                                />
                                {formErrors.nationality && (
                                    <InputError error={formErrors.nationality} />
                                )}
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <div className="input-common">
                                <label>Phone Number</label>
                                <PhoneInput
                                    className="PhoneNumber-input mt-15"
                                    country={formData?.countryVal?.toLowerCase()}
                                    value={formData.phone}
                                    onChange={handlePhoneChange}
                                    inputStyle={{
                                        width: "100%",
                                        height: "47px",
                                        fontSize: "16px",
                                        borderRadius: "4px",
                                        paddingLeft: "48px",
                                        backgroundColor: "#181A20",
                                    }}
                                    containerStyle={{ width: "100%" }}
                                    buttonStyle={{ borderRadius: "4px" }}
                                    enableSearch
                                    international
                                    countryCodeEditable={false}
                                />
                                {formErrors.phonenumber && (
                                    <InputError error={formErrors.phonenumber} />
                                )}
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <div className="blu-btn display-3 mt-20">
                                {
                                    load === true ?
                                        <Button className="" disabled>Progressing</Button>
                                        :
                                        <Button className="" onClick={handleSubmit}>Save Settings</Button>

                                }
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Box>
        </div>
    );
}

export default MyProfile;
